import PostsSerializer from './base';

export default class PageSet extends PostsSerializer {}
